// extracted by mini-css-extract-plugin
export default {"avatar":"styles_avatar__dRR0j","actionButtons":"styles_actionButtons__vdGTW","right":"styles_right__s1K+f"};